export default __webpack_public_path__ + "static/media/Butterfly.1328d2f9.png";